import { IFriend } from '../../../../interfaces/friend.interface';
import { IUser } from '../../../../store/apiSlice/chat/chatApi';

export const mapFriendToUser = (friend: IFriend): IUser => ({
  id: friend.userId,
  firstName: friend.firstName ?? '',
  lastName: friend.lastName ?? '',
  thumbnail: friend.avatarUrl ?? '',
  sports: friend.sports,
});
